'use strict';

function EMTController() {
  this.id = null;
  this.node = null;
  this.extends = [_AccountController, _Paths];
  this.presenter = $('[data-mogo-ui=Portal]').mogo().presenter;

  this.createEmtAction = 'account.create_emt_request';
  this.getEmtAction = 'account.get_emt_request';
  this.EMT_REQUEST_MODEL = 'emt.requests';
  this.EMT_LATEST_REQUEST = 'emt.latestRequest';

  this.emtRequestProduct = null;
  this.emtRequestId = null;
  this.emtRequestModelPromise = $.Deferred();

  this.pollActionInterval = 3000;

  this.init = function () {
    this.setEmtRequestProduct();
    this.emtFlowRouteCheck();

    if (!this.presenter.models.emt) {
      this.presenter.createModel('emt', {
        data: {}
      });
    }

    this.getEmtRequests();

    $.when(this.emtRequestModelPromise).then(function () {
      // Placeholder for future
    });
  };

  /* 
    emtFlowRouteCheck: checks if the feature is enabled, if not routes all
    emt flow views back to the dashboard fund view.
  */
  this.emtFlowRouteCheck = function () {
    if (!this.isEmtEnabled()) return this._history.replaceUrl(this.paths.emt[this.emtRequestProduct].fund);
  };

  /* 
    setEmtRequestProduct: Sets the Emt Flow Product by referencing appState.
    Looks for /member/dashboard/crypto pathname to determine product as FALLBACK. 
  */
  this.setEmtRequestProduct = function () {
    if (!this.presenter.models.appState.layout.active_section) {
      var cryptoPath = /^(https:\/\/(localhost|(www|qa|dev|demo).mogo.ca)\/member\/dashboard\/crypto)|^\/member\/dashboard\/crypto/;
      var currentUrl = window.location.pathname;

      this.emtRequestProduct = cryptoPath.test(currentUrl) ? 'crypto' : 'card';
    } else {
      this.emtRequestProduct = this.presenter.models.appState.layout.active_section.toLowerCase();
    }
  };

  /* 
    getEmtStatus: Gets the current product flow EMT transaction status.
    Run this method after emtModelPromise has been resolved.
  */
  this.getEmtStatus = function () {
    var status = this.presenter.getModelProperty(this.EMT_REQUEST_MODEL + '.' + this.emtRequestProduct + '.status');

    if (status) {
      // Deposit initiated and Deposit Pending will display the same pending related screen.
      return status === 'DEPOSIT_INITIATED' || status === 'DEPOSIT_PENDING' ? 'PENDING' : status;
    }
    return '';
  };

  this.getEmtRequestId = function () {
    var status = this.presenter.getModelProperty(this.EMT_LATEST_REQUEST + '.request_id');

    return status || null;
  };

  /* 
    isEmtInProgress: Method returns a boolean if it is one of the progress statuses.
  */
  this.isEmtInProgress = function () {
    var statusArr = ['FAILED', 'EXPIRED', 'DEPOSIT_INITIATED', 'DEPOSIT_PENDING', 'AVAILABLE'];

    var status = this.presenter.getModelProperty(this.EMT_REQUEST_MODEL + '.' + this.emtRequestProduct + '.status');

    return statusArr.includes(status);
  };

  /*
    isEmtEnabled: Method returns boolean by checking `EmtRequests`
    in feature control table
  */
  this.isEmtEnabled = function () {
    var featureName = 'EmtRequests';
    return this.presenter.featureControls.isEnabled(featureName);
  };

  /* 
    pollEmtStatus [callback: function]: Method to start polling getEmtAction.
    Add a callback from action, saves the response to `emt.requests` everytime 
    it calls getEmtAction. Invokes callback after stop polling.
  */
  this.pollEmtStatus = function (requestId, callback) {
    if (this.presenter.hasAction(this.getEmtAction)) {
      // Remove existing action callback before starting new one
      if (this.emtStatusCallbackId) {
        this.presenter.removeCallbackFromAction(this.getEmtAction, this.emtStatusCallbackId);
      }

      var emtPollingPayload = null;

      if (requestId) {
        emtPollingPayload = {
          product: this.emtRequestProduct,
          request_id: requestId
        };
      }

      this.emtStatusCallbackId = this.presenter.addCallbackToAction(this.getEmtAction, this._onPollEmtStatusCallback.bind(this, callback));

      this.presenter.startPollAction(this.getEmtAction, this.pollActionInterval, null, emtPollingPayload);
    }
  };

  this._onPollEmtStatusCallback = function (callback, data, response) {
    if (response !== 200) {
      this.presenter.stopPollAction(this.getEmtAction);
      callback(data[this.emtRequestProduct], response);
    } else {
      //  Each Page should have the emt.requests model on init
      this.presenter.updateModel('' + this.EMT_REQUEST_MODEL, data, function () {
        if (callback) callback();
      });
    }
  };

  /* 
    stopPollEmtStatus [callback: function]: Method to stop polling getEmtAction.
    Removes the callback from action, invokes callback after stop polling.
  */
  this.stopPollEmtStatus = function (callback) {
    if (this.emtStatusCallbackId) {
      this.presenter.removeCallbackFromAction(this.getEmtAction, this.emtStatusCallbackId);
    }
    this.presenter.stopPollAction(this.getEmtAction);
    if (callback) callback();
  };

  this._onGetEmtVelocity = function (callback, data, response) {
    if (response === 200) {
      this.presenter.setModelProperty('emt.velocity.' + this.emtRequestProduct, data);
      if (callback) callback(data, response);
    }
  };

  /* 
    isWithinVelocityLimit (amount: number): Method to check if the amount is within the velocity limit.
    A/C to stop user submission on the client side. 
  */
  this.isWithinVelocityLimit = function (amount) {
    var requestProductVelocityModel = 'emt.velocity.' + this.emtRequestProduct;
    var velocity = this.presenter.getModelProperty(requestProductVelocityModel);

    return amount < velocity['24h_velocity_limit'] && amount < velocity['24h_remaining_deposit'];
  };

  /* 
    createEmtRequest:
      payload: {amount: number, product: string}
      callback: function
      
    Posts to the createEmtAction endpoint and saves the 
    response WITH THE PRODUCT KEY to `emt.requests` model. 
    Invokes callback when model is created/updated.
  */
  this.createEmtRequest = function (payload, callback) {
    if (this.presenter.hasAction(this.createEmtAction)) {
      var formattedPayload = {
        amount: Number(payload.amount),
        product: payload.product
      };

      this.presenter.performAction(this.createEmtAction, formattedPayload, this._onCreateEmtRequest.bind(this, callback));
    } else {
      console.error('EMTController: no action error ' + this.createEmtAction);
    }
  };

  this._onCreateEmtRequest = function (callback, data, response) {
    if (response === 200) {
      // response does not have a product key. Making this response structure
      // the same as the get_emt_request response
      var productObj = {};
      productObj[this.emtRequestProduct] = data;

      // EdgeCase: In some instances, users will start at the amount screen,
      // at this point, the page does not have emt.requests model created
      // if get_emt_request fails onn a 400.
      if (!this.presenter.getModelProperty('' + this.EMT_REQUEST_MODEL)) {
        this.presenter.createModel('' + this.EMT_REQUEST_MODEL, productObj, function () {
          if (callback) callback(data, response);
        });
      } else {
        this.presenter.updateModel('' + this.EMT_REQUEST_MODEL, productObj, function () {
          if (callback) callback(data, response);
        });
      }
    } else if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Emt'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      this._displayErrorNotification(data);
    }
  };

  /* 
    getEmtRequests [callback: function]: Calls the getEmtAction endpoint and saves the 
    response to the `emt.requests` model. Invokes callback when model is created/updated.
  */
  this.getEmtRequests = function (callback) {
    var getEmtRequestPayload = null;
    // Check for existing request id thats cached
    var requestId = this.getEmtRequestId();

    if (requestId) {
      getEmtRequestPayload = {
        product: this.emtRequestProduct,
        request_id: requestId
      };
    }

    if (this.presenter.hasAction(this.getEmtAction)) {
      this.presenter.performAction(this.getEmtAction, getEmtRequestPayload, this._onGetEmtRequest.bind(this, callback));
    } else {
      console.error('EMTController: no action error ' + this.getEmtAction);
    }
  };

  this._onGetEmtRequest = function (callback, data, response) {
    if (response === 200) {
      if (!this.presenter.getModelProperty('' + this.EMT_REQUEST_MODEL)) {
        this.presenter.createModel('' + this.EMT_REQUEST_MODEL, { data: data }, function () {
          if (callback) callback(data, response);
        });
      } else {
        this.presenter.updateModel('' + this.EMT_REQUEST_MODEL, data, function () {
          if (callback) callback(data, response);
        });
      }
      this.emtRequestModelPromise.resolve();
    } else if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Emt'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      this._displayErrorNotification(data);
    }
  };

  /*
    _displayErrorNotification [data: (obj from be)]: display orange error banner, this
    is the default mogo error pattern when its not a internal microservice error
    see isGeneralConnectionIssue for more details
    Go to documentation below for error responses
    https://mogofintech.atlassian.net/wiki/spaces/PT/pages/1573552481/TDD+Wallet+Interac+e-Transfer+Request+Funding
  */
  this._displayErrorNotification = function (data) {
    $('#Notification').mogo().create({
      type: 'custom',
      msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
      customClass: 'loan-application-notification--warning',
      notificationDescriber: 'error'
    });

    $.each(data.errors, function (index, element) {
      console.warn('key: ' + element.key + ', msg: ' + element.msg);
    });
  };

  /* 
    getEmtRequestIframe: Gets the current request_fulfillment_url flow EMT transaction status.
    Run this method after emtModelPromise has been resolved.
  */
  this.getEmtRequestIframe = function () {
    var modelProperty = this.EMT_REQUEST_MODEL + '.' + this.emtRequestProduct + '.request_fulfillment_url';
    return this.presenter.getModelProperty(modelProperty) ? this.presenter.getModelProperty(modelProperty) : '';
  };

  this.getEmtProductFlow = function (string) {
    var redirectProductPath = this.paths.emt[this.emtRequestProduct][string];

    if (redirectProductPath) return redirectProductPath;

    return console.warn('EMTController: Unable to find product path');
  };

  /*
    _saveEmtRequest: cache latest emt request, for request_id
    request_id is used in the GET call
  */
  this._saveLatestEmtRequest = function (data) {
    this.presenter.setModelProperty(this.EMT_LATEST_REQUEST, data);
  };

  /*
  _removeProgressLoader: hides progress loader and displays the loaded 
  body content. Need to add .progress-spinner HTML and .js--emt-component-loaded-body class
  to the content thats being loaded
   .loader.js--progress-loader
    .progress-spinner
  */

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$emtLoader = document.querySelector('.js--progress-loader');
    this._$emtLoadedBody = document.querySelector('.js--emt-component-loaded-body');

    // Hide page loader
    this._$emtLoader.classList.add('hide');
    this._$emtLoadedBody.classList.remove('hide');
  };

  this.destroy = function () {
    this.stopPollEmtStatus();
  };
}